import Vue from 'vue';
import FactoryComponents from '../../../../factory/components/FactoryComponents.js';
const root = {}
export default root
root.name = 'userManager';
root.data = {
	titleName: '',

	loginLogData: {
		list: [],
		//总页数
		total: 1,
		//每页多少行
		limit: 10,
		//当前页数
		thisPage: 1,
		//模糊查询
		searchName: '',

		tableData: [{
				title: '账号',
				key: 'account'
			},
			{
				title: '名称',
				key: 'name'
			},
			{
				title: 'IP',
				key: 'ip',
			},
			{
				title: '类型',
				key: 'type',
			},
			{
				title: '时间',
				slot: 'loginTime',
				sortable: true
			}
		],
	}
};
root.methods = {
	
	getLoginLog: function(page){
		const that = this;
		let formdata = new FormData();
		formdata.append("account", this.loginLogData.searchName);
		formdata.append("curPage", page);
		formdata.append("limit", this.loginLogData.limit);
		this.componentsMoudel.getRequestHander(this.componentsMoudel.getData('urls').selectLoginLog)
			.openLoad().startPost(formdata).then((res) => {
				that.loginLogData.total = res.body.cum;
				that.loginLogData.list = res.body.data
			});
	},
	
	calculationLoginTime: function(item){
		return item.gmtCreate;
	}

};
root.mounted = function() {
	// let menuDatas = this.componentsMoudel.getData(this.$route.path);
	// this.titleName = menuDatas.menuName;
	this.titleName = '登录日志';
	this.getLoginLog(1);
};

FactoryComponents.initComponent(root);
